import css from 'styled-jsx/css';
import typography from '../../../../styles/typography';

export const styles = css`
    .NovaPoshtaSeoText {
      margin-top: 60px;
    }
    .NovaPoshtaSeoText_withTopMargin {
      margin-top: 16px;
    }
    .NovaPoshtaSeoText__content {
      ${typography.text}
    }
  `;
